<div class="hero_area2">
    <app-menu [config]="config"></app-menu>
    <!-- <app-carrossel [config]="config"></app-carrossel> -->
</div>

<app-area-cliente-body [config]="config"></app-area-cliente-body>


